module.exports = __webpack_public_path__ + "img/svg/icon-heart.2cc33028fdff309b8b18838da0707da9.svg";